export const chatsTypes = {
  LOGIN_USER_START: "LOGIN_USER_START",
  RESET_PASSWORD_START: "RESET_PASSWORD_START",
  LOGOUT_USER: "LOGOUT_USER",
  CONNECT_CHATS_SOCKET: "CONNECT_CHATS_SOCKET",

  UPDATE_PENDING_CONVERSATIONS: "UPDATE_PENDING_CONVERSATIONS",
  UPDATE_ONGOING_CONVERSATIONS: "UPDATE_ONGOING_CONVERSATIONS",
  SET_SELECTED_CONVERSATIONS: "SET_SELECTED_CONVERSATIONS",
  FETCH_CONVERATION_INFO: "FETCH_CONVERATION_INFO",
  SET_USER_CONVERSATION_INFO: "SET_USER_CONVERSATION_INFO",

  SET_SELECTED_CONVERSATION: "SET_SELECTED_CONVERSATION",
  SET_NEW_MESSAGE: "SET_NEW_MESSAGE",
  REMOVE_CONVERSATION_NOT_SEEN: "REMOVE_CONVERSATION_NOT_SEEN",
  REMOVE_CONVERSATION_NOT_SEEN_BADGE: "REMOVE_CONVERSATION_NOT_SEEN_BADGE",
  SEND_TEXT_MESSAGE: "SEND_TEXT_MESSAGE",
  SEND_FILE_MESSAGE: "SEND_FILE_MESSAGE",
  SET_DELIVERED_MESSAGE: "SET_DELIVERED_MESSAGE",
  ACCEPT_CONVERSATION_START: "ACCEPT_CONVERSATION_START",
  CLOSE_CONVERSATION_START: "CLOSE_CONVERSATION_START",
  ADD_CONVERSATION_TO_ONGOINGS: "ADD_CONVERSATION_TO_ONGOINGS",
  REMOVE_CLOSED_CONVERSATION: "REMOVE_CLOSED_CONVERSATION",

  SET_TRANSFERED_CHAT: "SET_TRANSFERED_CHAT",
  REMOVE_CONV_FROM_LIST: "REMOVE_CONV_FROM_LIST",
  TRANSFER_CONVERSATION_START: "TRANSFER_CONVERSATION_START",
  ACCEPT_TRANSFERED_CONVERSATION_START: "ACCEPT_TRANSFERED_CONVERSATION_START",
  REJECT_TRANSFERED_CONVERSATION_START: "REJECT_TRANSFERED_CONVERSATION_START",
  SET_TRANSFERED_CHAT_CONVERSATION: "SET_TRANSFERED_CHAT_CONVERSATION",
  HANDLE_ACCEPTED_CONVERSATION: "HANDLE_ACCEPTED_CONVERSATION",
  SET_PRETEXTS: "SET_PRETEXTS",
  ADD_PRETEXT_START: "ADD_PRETEXT_START",
  REMOVE_PRETEXT_START: "REMOVE_PRETEXT_START",
  EDIT_PRETEXT_START: "EDIT_PRETEXT_START",
  BLOCK_USER_START: "BLOCK_USER_START",
  UPDATE_USER_INFO: "UPDATE_USER_INFO",
  UPDATE_USER_AVATAR: "UPDATE_USER_AVATAR",
  UPDATE_CONVERSATION_AVATAR: "UPDATE_CONVERSATION_AVATAR",
  SET_UPDATED_USER: "SET_UPDATED_USER",

  CLOSE_ALL_CONVERSATIONS: "CLOSE_ALL_CONVERSATIONS",
  SET_AGENT_ONLINE: "CHANGE_AGENT_ONLINE",

  FETCH_ONLINE_USER_CONVERSATION: "FETCH_ONLINE_USER_CONVERSATION",
  SET_ONLINE_USERS_BADGE_START: "SET_ONLINE_USERS_BADGE_START",
  CHAT_WITH_ONLINE_USER_START: "CHAT_WITH_ONLINE_USER_START",
  CHAT_WITH_PARTNER_START: "CHAT_WITH_PARTNER_START",
  SET_PARTNER_NEW_MESSAGE: "SET_PARTNER_NEW_MESSAGE",

  PLAY_MESSAGE_NOTIFICATION_SOUND: "PLAY_MESSAGE_NOTIFICATION_SOUND",
  PLAY_NEW_VISITOR_SOUND: "PLAY_NEW_VISITOR_SOUND",
  UPDATE_NOTIFICATION_SOUNDS: "UPDATE_NOTIFICATION_SOUNDS",
  UPDATE_AGENT_PROFILE: "UPDATE_AGENT_PROFILE",
  UPDATE_TELEGRAM_BOT: "UPDATE_TELEGRAM_BOT",
  REFRESH_AGENT_INFO: "REFRESH_AGENT_INFO",
  SET_UNREAD_PENDING_MESSAGE: "SET_UNREAD_PENDING_MESSAGE",
  SET_UNREAD_ONGOING_MESSAGE: "SET_UNREAD_ONGOING_MESSAGE",
  FETCH_MORE_MESSAGES: "FETCH_MORE_MESSAGES",
  SET_SCROLL_TO_BOTTOM: "SET_SCROLL_TO_BOTTOM",
  LOGOUT_SOCKT: "LOGOUT_SOCKT",
  SET_LOADING_CHATS: "SET_LOADING_CHATS",

  SET_TYPING_WORD: "SET_TYPING_WORD",

  FETCH_AGENTS_START: "FETCH_AGENTS_START",
  FETCH_ONLINE_USERS_START: "FETCH_ONLINE_USERS_START",

  SET_ACTING_MESSAGE: "SET_ACTING_MESSAGE",
  EDIT_MESSAGE_START: "EDIT_MESSAGE_START",
  SET_EDITED_MESSAGE: "SET_EDITED_MESSAGE",
  SET_SEEN_STATUS_FOR_ALL_MESSAGES: "SET_SEEN_STATUS_FOR_ALL_MESSAGES",
  SET_MESSAGE_ID: "SET_MESSAGE_ID",

  SET_HAS_MORE_TO_LOAD_ON_GOING_CONVS_LIST:
    "SET_HAS_MORE_TO_LOAD_ON_GOING_CONVS_LIST",
  SET_HAS_MORE_TO_LOAD_PENDING_CONVS_LIST:
    "SET_HAS_MORE_TO_LOAD_PENDING_CONVS_LIST",
  SORT_ONGOING_CONVS_START: "SORT_ONGOING_CONVS_START",
  SET_USER_AVATAR_UPLOAD_PROGRESS: "SET_USER_AVATAR_UPLOAD_PROGRESS",

  FETCH_USER_ROADMAP: "FETCH_USER_ROADMAP",
  UPDATE_CHAT_FILE_UPLOAD_PROGRESS: "UPDATE_CHAT_FILE_UPLOAD_PROGRESS",

  ADD_PENDING_MESSAGE_TO_THE_LIST: "ADD_PENDING_MESSAGE_TO_THE_LIST",
  REMOVE_MESSAGE_FROM_PENDING_LIST: "REMOVE_MESSAGE_FROM_PENDING_LIST",

  FETCH_MORE_OTHER_OPERATORS_CONVS: "FETCH_MORE_OTHER_OPERATORS_CONVS",

  SET_HAS_MORE_TO_LOAD_OTHER_OPERATORS_CONVS:
    "SET_HAS_MORE_TO_LOAD_OTHER_OPERATORS_CONVS",

  SET_HAS_MORE_TO_LOAD: "SET_HAS_MORE_TO_LOAD",
  FETCH_MORE_OF_CONVS_LIST: "FETCH_MORE_OF_CONVS_LIST",

  TRANSFER_CONVERSATION_TO_ME: "TRANSFER_CONVERSATION_TO_ME",

  SET_TEAMS: "SET_TEAMS",

  SET_BLOCKED_USERS_LIST: "SET_BLOCKED_USERS_LIST",

  UNBLOCK_USER: "UNBLOCK_USER",

  SET_CONVERSATION_WITH_BOT_STATUS: "SET_CONVERSATION_WITH_BOT_STATUS",

  UPDATE_PENDING_CONVERSATION_BY_BOT_NEW_MSG:
    "UPDATE_PENDING_CONVERSATION_BY_BOT_NEW_MSG",

  GET_CLOSED_CONVERSATION: "GET_CLOSED_CONVERSATION",
  SET_NEW_ONLINE_USER_CONV: "SET_NEW_ONLINE_USER_CONV",
  SET_CONVERSATIONS_LIST: "SET_CONVERSATIONS_LIST",
  REFETCH_CONVERSATIONS_LISTS_START: "REFETCH_CONVERSATIONS_LISTS_START",

  REMOVE_TRANSFERRED_CHAT: "REMOVE_TRANSFERRED_CHAT",
};
